// extracted by mini-css-extract-plugin
export default {"headerText":"BulkApplyModuleAccessLevel__headerText___nuip8"};